import React from "react";
import { Home, ArrowRight } from "lucide-react";

export function SellProperty() {
  return (
    <section
      id="sell"
      data-testid="sell-section"
      className="bg-[var(--ivory)] py-24 lg:py-32"
    >
      <div className="max-w-[1180px] mx-auto px-6 lg:px-10">
        <div
          className="reveal relative bg-[var(--navy)] text-[var(--ivory)] grain-overlay overflow-hidden"
          style={{ boxShadow: "0 30px 80px -40px rgba(14,23,48,0.6)" }}
        >
          {/* gold top rule */}
          <span className="absolute top-0 left-0 right-0 h-[2px] bg-[var(--gold)]" />
          <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-10 lg:gap-16 items-center p-8 sm:p-12 lg:p-16">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-10 bg-[var(--gold)]" />
                <span className="text-[0.7rem] tracking-[0.32em] uppercase text-[var(--gold)]">
                  For Property Owners
                </span>
              </div>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.25rem] leading-[1.05]">
                Sell Your Property.
                <br />
                <span className="italic text-[var(--gold)]">Discreetly. Confidently.</span>
              </h2>
              <p
                className="mt-7 text-[1.02rem] leading-[1.75] max-w-xl"
                style={{ color: "rgba(245,240,232,0.82)" }}
              >
                We're actively looking to purchase all types of property across{" "}
                <span className="text-[var(--ivory)] font-medium">East London</span>,{" "}
                <span className="text-[var(--ivory)] font-medium">Stoke-on-Trent</span>, and{" "}
                <span className="text-[var(--ivory)] font-medium">Essex</span>.
                If you're considering selling, get in touch with our team for a
                discreet, hassle-free, and professional service — with an offer made
                within{" "}
                <span className="text-[var(--gold)] font-medium">48 hours of viewing</span>.
              </p>

              <div className="mt-9 flex flex-wrap items-center gap-5">
                <a
                  href="mailto:info@ascendpropertygroup.co.uk?subject=Property%20Sale%20Enquiry"
                  data-testid="sell-cta"
                  className="btn-gold"
                >
                  Request a Potential Offer
                  <ArrowRight size={18} />
                </a>
                <a
                  href="mailto:info@ascendpropertygroup.co.uk"
                  className="text-[0.8rem] tracking-[0.18em] uppercase text-[var(--ivory)]/80 hover:text-[var(--gold)] transition-colors"
                >
                  info@ascendpropertygroup.co.uk →
                </a>
              </div>

              <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
                {[
                  { v: "48h", l: "Offer turnaround" },
                  { v: "100%", l: "Confidential" },
                  { v: "All", l: "Property types" },
                ].map((s) => (
                  <div key={s.l} className="border-l border-[rgba(201,168,76,0.35)] pl-4">
                    <p className="font-display text-[1.7rem] text-[var(--gold)] leading-none">
                      {s.v}
                    </p>
                    <p className="text-[0.7rem] tracking-[0.18em] uppercase mt-2 text-[var(--ivory)]/70">
                      {s.l}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Right decorative panel */}
            <div className="relative hidden lg:flex items-center justify-center">
              <div className="relative w-full max-w-[360px] aspect-[3/4] border border-[rgba(201,168,76,0.35)] flex items-center justify-center">
                <span className="absolute top-3 left-3 w-6 h-6 border-l border-t border-[var(--gold)]" />
                <span className="absolute bottom-3 right-3 w-6 h-6 border-r border-b border-[var(--gold)]" />
                <div className="text-center px-6">
                  <Home size={42} className="mx-auto text-[var(--gold)]" strokeWidth={1.1} />
                  <p className="mt-6 font-display italic text-[1.5rem] leading-snug text-[var(--ivory)]">
                    "A quiet sale, handled with care."
                  </p>
                  <div className="mt-6 flex items-center justify-center gap-3">
                    <span className="h-px w-8 bg-[var(--gold)]" />
                    <span className="text-[0.65rem] tracking-[0.28em] uppercase text-[var(--gold)]">
                      East London · Stoke-on-Trent · Essex
                    </span>
                    <span className="h-px w-8 bg-[var(--gold)]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
